/**
 * Validates the "% extra assessment time" customisation for providers whose
 * API only accepts a whole number from 1 to 100 (e.g. Test Partnership's
 * FactorPercentage). Blank means no extra time.
 */
export const validateExtraTimePercentage = value => {
  const trimmed = value == null ? "" : String(value).trim()
  if (trimmed === "") {
    return {
      valid: true,
      message: "Candidates will not receive extra assessment time.",
    }
  }
  const percentage = Number(trimmed)
  if (!/^\d+$/.test(trimmed) || percentage < 1 || percentage > 100) {
    return {
      valid: false,
      message:
        "% extra assessment time must be blank or a whole number from 1 to 100.",
    }
  }
  return {
    valid: true,
    message: `Candidates will receive ${percentage}% extra assessment time.`,
  }
}
